var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAccountContact = function SvgIconAccountContact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.024 6.012a7.9 7.9 0 0 0 2.964 2.964l.664-.929a.75.75 0 0 1 .97-.222 8.6 8.6 0 0 0 3.437 1.023c.39.03.691.356.691.747v3.348a.75.75 0 0 1-.673.746q-.597.06-1.202.061C5.455 13.75.25 8.545.25 2.125q0-.605.061-1.202A.75.75 0 0 1 1.057.25h3.348c.39 0 .716.3.747.69a8.6 8.6 0 0 0 1.023 3.438.75.75 0 0 1-.222.97zm-1.89-.493L4.557 4.5a10 10 0 0 1-.823-2.751H1.757q-.007.188-.007.375c0 5.592 4.533 10.125 10.125 10.125q.188 0 .375-.007v-1.979a10 10 0 0 1-2.751-.822L8.48 10.867a9 9 0 0 1-1.19-.562l-.044-.025A9.4 9.4 0 0 1 3.72 6.753l-.025-.044a9 9 0 0 1-.562-1.19"
  })));
};
export default SvgIconAccountContact;